import Rest from './../../../plugins/Rest'
import validation from './../../../plugins/validation'
import { clone } from 'lodash'
import moment from 'moment'
import store from '../../../store/index'
import clearSearch from './../../../plugins/clearSearch'
const state = {
    modal: {
        fields: {
            title: '',
            contractor: '',
            representative: '',
            contractType: '',
            comment: '',
            signDate: '',
            number: '',
            expirationDate: '',
            contractor: '',
            representative: '',
        },
        errors: {
            stepOne: {
                validation: true,
                fields: {
                    title: '',
                    contractor: '',
                    number: '',
                    signDate: '',
                    contractType: '',
                },
            },
        },
        step: 1,
    },
    table: {
        items: [],
        total: '',
        search: '',
        page: 1,
        limit: 11,
        pages: 1,
        defaultSort: '-createdAt',
        loading: false,
    },
    contractInput: [],
    request: {
        populate: [
            {
                localField: 'contractor',
                foreignField: '_id',
                from: 'contacts',
                as: 'contractor',
            },

            {
                localField: 'createdBy',
                foreignField: '_id',
                from: 'users',
                as: 'createdBy',
            },
        ],
        searchFields: ['index', 'number'],
        defaultSearchFields: ['index'],
        select:
            'isDeleted _id title representative number createdAt expirationDate status contractType clientType comment index signDate contractor folders',
        where: {
            isDeleted: false,
        },
    },
    dictFields: {
        contractType: '',
    },
    input: {
        items: [],
        search: '',
        limit: 4,
        sort: 'number',
        defaultSort: 'number',
    },
    statuses: [],
    details: {},
    registry: {},
}

const getters = {
    getContractModal: state => state.modal.fields,
    getContractRegistry: state => state.registry,
    getContractTable: state => state.table,
    getContractSearchFields: state => state.request,
    getContractErrors: state => state.modal.errors,
    getContractStep: state => state.modal,
    getContractStatuses: state => state.statuses,
    getContractDetails: state => state.details,
    getContractsInput: state => state.input,

}

const actions = {
    async fetchContractsTable({ commit, dispatch }) {
        state.table.loading = true
        try {
            let table = await new Rest('GET', 'contracts')
                .select(state.request.select)
                .limit(state.table.limit)
                .page(state.table.page)
                .where(state.request.where)
                .populate(state.request.populate)
                .search(state.request.searchFields, state.table.search)
                .sort(state.table.sort || state.table.defaultSort)
                .send()

            let response = table
            dispatch('fetchContractRegistry')
            commit('setContractTable', response.data)
        } catch (error) {
            console.error(error)
        }
        state.table.loading = false
    },




    async createContract({ commit, dispatch }, payload) {
        try {
            await new Rest('POST', 'contracts')
                .setBody(state.modal.fields)
                .send()
            commit('clearContractModal')
            commit('clearContractErrors')
            dispatch('fetchContractsTable')
            commit('setSnackbars', { type: 'success' })
            return true
        } catch (err) {
            //HANDLE ERRORS
            if (err) {
                commit('setSnackbars', { type: 'error' })
                validation.setErrors(state.modal.errors, err)
            }
        }
    },

    async updateContract({ commit, dispatch }, payload) {
        try {
            await new Rest('PUT', `contracts/${payload.id}`)
                .setBody(state.modal.fields)
                .send()
            dispatch('fetchContract', { id: payload.id })
            commit('clearContractModal')
            commit('clearContractErrors')
            return true
        } catch (err) {
            //HANDLE ERRORS
            validation.setErrors(state.modal.errors, err)
            commit('setSnackbars', { type: 'error' })
        }
    },
    async fetchContract({ state, commit, dispatch }, payload) {
        try {
            let Contract = await new Rest('GET', `contracts/${payload.id}`)
                .populate(['contractor', 'createdBy'])
                .select(
                    '_id title representative number createdAt expirationDate status contractType clientType comment index signDate contractor'
                )
                .send()

            let statusesReq = new Rest('GET', `registries/contracts/statuses`)
                .select('name _id isDeleted color state')
                .where({ isDeleted: false })
                .send()

            let { 0: response, 1: statuses } = await Promise.all([
                Contract,
                statusesReq,
            ])
            dispatch('fetchContractRegistry')
            commit('setContractDetails', response.data)
            commit('setContractStatuses', statuses.data.items)

            if (payload.next) payload.next()
        } catch (err) {
            console.error(err)
        }
    },

    async fetchContractRegistry({ commit, dispatch }, payload) {
        let registry = await new Rest('GET', 'registries')
            .select('currentMenager name')
            .where({ url: 'contracts' })
            .populate([
                {
                    path: 'currentMenager',
                    select: 'name lastname mail status phone picture',
                },
            ])
            .send()

        commit('setContractRegistry', registry.data.items)
    },

    async updateContractStatus({ commit, dispatch }, payload) {
        commit('setContractModal')
        commit('setContractStatus', payload.status)
        try {
            await new Rest('PUT', `contracts/${payload.id}`)
                .setBody(state.modal.fields)
                .send()
            commit('setSnackbars', { type: 'success' })
        } catch (err) {
            console.error(err)
            commit('setSnackbars', { type: 'error' })
        }
    },
    async deleteContract({ commit, dispatch }, payload) {
        try {
            await new Rest('DELETE', `contracts/${payload.id}`).send()
            dispatch('fetchContractsTable')
            commit('setSnackbars', { type: 'success' })
            return true
        } catch (err) {
            console.error(err)
        }
    },
    async fetchContractsInput({ commit, dispatch }) {
        try {

            let response = await new Rest('GET', 'contracts')
                .select(state.request.select)
                .limit(state.table.limit)
                .page(state.table.page)
                .where(state.request.where)
                .populate(state.request.populate)
                .search(state.request.searchFields, state.input.search)
                .sort(state.table.sort || state.table.defaultSort)
                .send()
     
            commit('setContractsInput', response.data)
        } catch (err) {
            console.error(err)
        }
    },
}

const mutations = {
    setContractTable(state, payload) {
        state.table.items = payload.items || state.table.items
        state.table.total = payload.total || state.table.total
        if (payload.search != undefined) state.table.search = payload.search
        state.table.page = payload.page || state.table.page
        state.table.limit = payload.limit || state.table.limit
        state.table.pages = Math.ceil(state.table.total / state.table.limit)
        if (payload.sort != undefined) state.table.sort = payload.sort
    },
    setContractDetails(state, payload) {
        state.details = payload
    },
    setContractStatuses(state, payload) {
        state.statuses = payload
    },
    setContractModal(state, payload) {
        let obj = payload ? payload : clone(state.details)
        state.modal.fields = obj
        store.commit('setRepresentativesInput', {
            items: obj?.contractor?.representatives,
        })
        state.modal.fields.representative = obj?.contractor?.representatives?.find(
            e => e._id === obj.representative
        )
        state.modal.fields.expirationDate = obj.expirationDate
            ? moment(obj.expirationDate).format('YYYY-MM-DD')
            : ''
        state.modal.fields.signDate = obj.signDate
            ? moment(obj.signDate).format('YYYY-MM-DD')
            : ''
    },
    setContractStatus(state, payload) {
        state.modal.fields.status = payload
    },
    setContractRegistry(state, payload) {
        state.registry = payload[0]
    },
    clearContractModal() {
        state.modal.step = 1
        state.modal.fields = {
            title: '',
            status: '',
            contractType: '',
            contractor: '',
            representative: '',
            notes: '',
            expirationDate: '',
        }
    },
    clearContractErrors(state) {
        for (const step in state.modal.errors) {
            for (const key in state.modal.errors[step].fields) {
                state.modal.errors[step].fields[key] = ''
                state.modal.errors[step].validation = true
            }
        }
    },
    clearContractTable(state) {
        clearSearch.clearSearchTable(state)
    },
    setContractSearch(state, payload) {
        state.request.searchFields = payload
    },
    setContractsInput(state, payload) {
        state.input.items = payload.items || state.input.items
        if (payload.search != undefined) state.input.search = payload.search
        state.input.limit = payload.limit || state.input.limit
        if (payload.sort != undefined) state.input.sort = payload.sort
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
